module.exports = __webpack_public_path__ + "static/img/kv1@2x.def78597.png";